import styled from 'styled-components';

export const StickyRowHeader = styled.thead`
    tr {
        position: relative;
        z-index: 2;
    }
    &::before {
        position: absolute;
        background: var(--app-background);
        height: calc(100% + 5px);
        width: 100%;
        content: '';
        z-index: 1;
    }
`;

export const StickyRowHeaderFilter = styled(StickyRowHeader)`
    top: 46px !important;
    &::before {
        display: none !important;
    }
`;
